import AgreementsDocumentFile from './AgreementsDocumentFile'
import { BaseModel, convertToModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class AgreementsDocumentVersion extends BaseModel {
  static override constructorName = 'AgreementsDocumentVersion'

  id: string = ''
  version: string = ''
  url: string = ''
  isActual: boolean = false
  file: AgreementsDocumentFile | null = null

  constructor(data?: unknown) {
    super(data)

    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['file'])

      this.file = convertToModel(data.file, AgreementsDocumentFile)
    }
  }

  get sourceLink(): string {
    return this.url || this.file?.source || ''
  }
}

registerModel(AgreementsDocumentVersion)
